import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: null,
    devexp: null,
    footprints: null,
    building: null,
    density_data:null,
    dataWarehouse: null,
    all_buildings_name:null,
  },
  mutations: {
    user(state, payload) {
      state.user = payload;
    },
    logout(state) {
      state.user = null;
    },
    devexp(state, payload) {
      state.devexp = payload;
    },
    footprints(state, payload) {
      state.footprints = payload;
    },
    building(state, payload) {
      state.building = payload;
    },
    density_data(state, payload) {
      state.density_data =  payload;
    },
    dataWarehouse(state, payload) {
      state.dataWarehouse = payload;
    },
    all_buildings_name(state, payload) {
      state.all_buildings_name = payload;
    }
  },
})
